import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { DatePipe } from '@angular/common';
import { TblLeadCampaign } from 'src/app/shared/models/leadcampaign';
import { LeadCampaignService } from 'src/app/shared/services/leadcampaign.services';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { EditLeadCampaignDialogComponent } from './edit-lead-campaign-dialog.component';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-Campaign',
  templateUrl: './lead-campaign.component.html',
  styleUrls: ['./lead-campaign.component.css']
})
export class LeadCampaignComponent implements OnInit {
  model: TblLeadCampaign;
  members: Observable<TblLeadCampaign[]>;
  allItems: TblLeadCampaign[] = [];
  pagedItems: TblLeadCampaign[] = [];
  pager: any = {};
  userType: string;
  constructor(private _leadCampaignService : LeadCampaignService,
    private dialog: MatDialog,
    private modalService: BsModalService,
    private localStorage:LocalStorageService,
    private spinnerService: AppComponent ,private notifyService : NotificationService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model=new TblLeadCampaign();
    this.getAllData();
  }
  getAllData(){
    this.members= this._leadCampaignService.getAllLeadCampaign();
    this.members.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  deleteClick(id:any)
  {
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = {mode:'Delete',  module: 'Lead Campaign', refNo:id};
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))
  }
  openAddDialog() {
    const model = new TblLeadCampaign();
    const dialogRef = this.dialog.open(EditLeadCampaignDialogComponent, {
      width: '500px',
      data: { title: 'New Lead Campaign', model: model, isEditing: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.model = result.model;
        this.create_edit_after_dialog(false);
      }
    });
  }

  openEditDialog(id: any) {
    this._leadCampaignService.getLeadCampaignById(id).subscribe(resp => {
      const dialogRef = this.dialog.open(EditLeadCampaignDialogComponent, {
        width: '500px',
        data: { title: 'Edit Lead Campaign', model: resp, isEditing: true }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'save') {
          this.model = result.model;
          this.create_edit_after_dialog(true);
        }
      });
    });
  }


  //Editing Data
  validateForm():boolean{
    
    if(!this.model.campaignName){
      this.notifyService.showError("Campaign Name can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }

  create_edit_after_dialog(isEditing: boolean){
    if(!this.validateForm()){
      return;
    }
    this._leadCampaignService.saveAndUpdateLeadCampaign(this.model).subscribe(resp=>{
      if(resp.refNo>0){
        this.notifyService.showSuccess(isEditing ? "Updated Successfully!" : "Saved Successfully!", "Success");
        this.getAllData()
      }
      else{
        this.notifyService.showError(resp.message, "Error")
      }
    },(err) => {
      this.notifyService.showError(err, "Error")
    });
  }
  close_clicked()
  {
    this.getAllData();
  }
  stopPropagation(event){
    event.stopPropagation();
    }
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}
